// Types
import {successGenerate} from '../common'
import * as Types from './types'
// Helpers

import {modalProps} from './modal.props'

const INIT_STATE: modalProps = {
  deleteModalOpen: false,
  deleteModalField:{deleteModalHandle:() => {},buttonText:"",title:"",contentId:0,content:""},
  storyReadingModalOpen:false,
  storyReadingModalField:{StoryId:0,StoryDetailId:0,LanguageCode:''},
  storyDetailModalField:{StoryId:0,StoryDetailId:0,LanguageCode:''},
  studentDetailModalField:{UserId:0},
  questionDetailModalField:{LanguageCode:'',StoryId:0,ShowType:''},
  studentDetailModalOpen:false,
  storyDetailModalOpen:false,
  questionDetailModalOpen:false
}

const modalReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.DELETE_MODAL_OPEN):
      return {
        ...state,
        deleteModalOpen: true,
        deleteModalField: payload.data,
      }
    case successGenerate(Types.DELETE_MODAL_CLOSE):
      return {
        ...state,
        deleteModalOpen: false,
      }

    case successGenerate(Types.STORY_READING_MODAL_OPEN):
      return {
        ...state,
        storyReadingModalOpen: true,
        storyReadingModalField:payload.data
      }
    case successGenerate(Types.STORY_READING_MODAL_CLOSE):
      return {
        ...state,
        storyReadingModalOpen: false,
      }


    case successGenerate(Types.STORY_DETAIL_MODAL_OPEN):
      return {
        ...state,
        storyDetailModalOpen: true,
        storyDetailModalField:payload.data
      }
    case successGenerate(Types.STORY_DETAIL_MODAL_CLOSE):
      return {
        ...state,
        storyDetailModalOpen: false,
        studentDetailModalField:{UserId:0}
      }

    case successGenerate(Types.STUDENT_DETAIL_MODAL_OPEN):
      return {
        ...state,
        studentDetailModalOpen: true,
        studentDetailModalField:payload.data
      }
    case successGenerate(Types.STUDENT_DETAIL_MODAL_CLOSE):
      return {
        ...state,
        studentDetailModalOpen: false,
      }

    case successGenerate(Types.QUESTION_DETAIL_MODAL_OPEN):
      return {
        ...state,
        questionDetailModalOpen: true,
        questionDetailModalField:payload.data
      }
    case successGenerate(Types.QUESTION_DETAIL_MODAL_CLOSE):
      return {
        ...state,
        questionDetailModalOpen: false,
      }
    default:
      return state
  }
}

export {modalReducer}
